module.exports = __webpack_public_path__ + "img/Assuta_Hospital.b1e576d0.svg";